<template>
  <div class="wrap">
    <div class="title">工事一覧</div>
    <div class="construction-list">
      <div class="row">
        <div class="construction-shared head">
        </div>
        <div class="construction-name head">
          工事名
        </div>
        <div class="construction-owner head">
          管理者
        </div>
        <div class="modified-at head">
          最終更新日
        </div>
      </div>
      <div v-for="(construction, idx) in constructionList" :key="idx"
           class="row">
        <div class="construction-shared">
          <div class="construction-shared-icon" v-if="construction.is_shared"><img src="@/assets/shared_folder.png"></div>
        </div>
        <div class="construction-name">
          <router-link :to="{ name: 'create-kokuban-detail', params: { cloudConstructionId: construction.cloud_construction_id } }">
            {{ construction.cloud_construction_name }}
          </router-link>
        </div>
        <div class="construction-owner">{{ construction.owner_cloud_user_name }}</div>
        <div class="modified-at">
          {{ formatTimestamp(construction.modified_at) }}
        </div>
      </div>
    </div>
    <div class="btn-wrap">
      <button class="cre-btn"
              @click="() => { this.newConstructionName = ''; $refs.theCreateConstructionDialog.show() }">
        クラウド工事作成
      </button>
    </div>
    <DialogPanel modal-name="create-construction-dialog"
                 main-button-text="作成"
                 @main-button-click="createConstruction()"
                 second-button-text="キャンセル"
                 @second-button-click="() => { $refs.theCreateConstructionDialog.hide() }"
                 ref="theCreateConstructionDialog">
      <div class="dialog-title">
        クラウド工事作成
      </div>
      <div class="construction-name-input-wrap">
        <label>名称</label>
        <ValidationInput field-name="工事名"
                         :valid-rules="newConstructionNameValidRules"
                         ref="newConstructionNameInput">
          <input type="text" v-model="newConstructionName" />
        </ValidationInput>
      </div>
    </DialogPanel>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'CreKokuban',
  props: {
    constructionList: Array
  },
  components: {
    DialogPanel: () => import('@/components/ui/DialogPanel.vue'),
    ValidationInput: () => import('@/components/ui/ValidationInput.vue')
  },
  data() {
    return {
      newConstructionName: '',
      newConstructionNameValidRules: { 
        required: true,
        exists_construction_excluded: []
      }
    }
  },
  watch: {
    constructionList: {
      handler() {
        let names = [];
        this.constructionList.forEach(construction => {
          if (construction.is_owner){
            names.push(construction.cloud_construction_name);
          }
        });
        // 登録済みの工事名を無効な値にする
        this.$set(this.newConstructionNameValidRules, 'exists_construction_excluded', names);
      },
      immediate: true
    }
  },
  methods: {
    createConstruction() {
      if (!this.$refs.newConstructionNameInput || !this.$refs.newConstructionNameInput.$children[0].flags.valid) {
        alert('工事名の入力を確認してください。');
        return;
      }
      const args = {
        construction_name: this.newConstructionName
      };
      this.$store.dispatch('api/createCloudConstruction', args).then(() => {
        if (this.$store.getters['api/apiError']) {
          return;
        }
        this.$emit('get-list');
        this.$refs.theCreateConstructionDialog.hide();
        this.newConstructionName = '';
      })
    },
    formatTimestamp(timestamp) {
      return moment.unix(timestamp).format('Y/M/D')
    }
  }
}
</script>

<style scoped>
.wrap {
  padding: 3rem;
}
.title {
  border-bottom: solid 1px #333;
  font-size: 1.4rem;
  font-weight: bold;
  padding: 2rem 1rem;
}
.construction-list {
  padding: 2rem 1rem;
}
.row {
  margin: 1rem 0;
  line-height: 2;
}
.construction-name.head,
.modified-at.head,
.construction-owner.head {
  font-weight: bold;
}
.construction-shared {
  display: inline-block;
  vertical-align: top;
  margin-right: 1rem;
  width: 1rem;
}
.construction-name {
  display: inline-block;
  vertical-align: top;
  margin-right: 1rem;
  width: 50%;
}
.construction-owner {
  display: inline-block;
  vertical-align: top;
  margin-right: 1rem;
  width: 25%;
}
.modified-at {
  display: inline-block;
  vertical-align: top;
  /* 4rem = sharedのwidth+margin + nameのmargin + ownerのmargin */
  width: calc(25% - 4rem);
}
.btn-wrap {
  padding: 1rem;
  text-align: center;
}
.cre-btn {
  background-color: #666;
  border: none;
  color: white;
  cursor: pointer;
  padding: 1rem 2rem;
}
.dialog-title {
  font-size: 1.2rem;
  font-weight: bold;
  padding: 1rem 2rem;
}
.construction-name-input-wrap {
  margin-bottom: 3rem;
  width: 100%;
  text-align: center;
}
.construction-name-input-wrap label {
  font-size: 1.1rem;
  margin-right: 1rem;
}
.construction-name-input-wrap input {
  width: 80%;
  border-radius: 0.5rem;
  border: solid 1px #333;
  font-size: 1.1rem;
  padding: 0.8rem;
  text-align: left;
}
</style>